import { render, staticRenderFns } from "./CrearLaboratorio.vue?vue&type=template&id=7415efeb"
import script from "./CrearLaboratorio.vue?vue&type=script&lang=js"
export * from "./CrearLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports